import {
    adminGuideTagsControllerGetTags,
    adminGuideTagsControllerCreateTag,
    adminGuideTagsControllerUpdateTag,
    adminGuideTagsControllerDeleteTag,
} from "../api/generated";

// Migrated to the generated client. The server derives the company from the authed principal,
// so the endpoint has no `companyId` query param; the arg is kept for signature parity but not
// forwarded. Returns {data: GuideTagDto[]} so callers keep reading `res.data`.
export const getGuideTags = async (companyId) => {
    const {data, error} = await adminGuideTagsControllerGetTags();
    if (error) throw error;
    return {data};
};

// Migrated. The request body is {name} only — the server ignores any extra `companyId` the
// caller passes (and the generated body type rejects it), so we forward only `name`.
export const saveGuideTag = async (data) => {
    const {data: resData, error} = await adminGuideTagsControllerCreateTag({
        body: {name: data.name},
    });
    if (error) throw error;
    return {data: resData};
};

export const updateGuideTag = async (id, data) => {
    const {data: resData, error} = await adminGuideTagsControllerUpdateTag({
        path: {id},
        body: {name: data.name},
    });
    if (error) throw error;
    return {data: resData};
};

export const deleteGuideTag = async (id) => {
    const {data, error} = await adminGuideTagsControllerDeleteTag({path: {id}});
    if (error) throw error;
    return {data};
};
